import { render, staticRenderFns } from "./PermissionDialog.vue?vue&type=template&id=1da82f71&scoped=true"
import script from "./PermissionDialog.vue?vue&type=script&lang=js"
export * from "./PermissionDialog.vue?vue&type=script&lang=js"
import style0 from "./PermissionDialog.vue?vue&type=style&index=0&id=1da82f71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da82f71",
  null
  
)

export default component.exports